module.exports = __webpack_public_path__ + "generic.e6c432.svg";